import apiFetch from 'api/base'
import { AxiosPromise } from 'axios'
import { ILanguage } from 'static/languages'

const loginByFacebook = (data: {
  visitorId: string
  providerUserToken?: string
  language?: ILanguage['locale']
}): AxiosPromise => apiFetch(`/socialauth/login/facebook`, { data, method: `POST` })

export default loginByFacebook
